import { formatMoneyKr } from '../../utils/index';
import VisibleIf from '../../components/VisibleIf';
import SearchBanner from '../../search/search-banner/SearchBanner';
import HowProjectWorks from '../how-project-works/HowProjectWorks';
import ProjectCardList from '../project-card-list/ProjectCardList';
import styles from './show-selected-projects.module.less';

const ShowSelectedProjects = (props) => {
    const {
        projectIds,
        projects,
        showSum = false,
        totalAmountCollected = 0,
        actionInformation = 'Selection',
        hideProjectImages = false,
        hideSiteSearch = false,
        searchReturnedEmpty = false,
        search = null,
    } = props;

    const numberOfProjects = projectIds?.length || projects?.length || 0;

    return (
        <div className={styles.container}>
            {search}
            <div className={styles.projectCardsList}>
                <VisibleIf isVisible={showSum}>
                    <div className={styles.projectsSum}>{formatMoneyKr(totalAmountCollected)} samlet inn totalt</div>
                </VisibleIf>
                <VisibleIf isVisible={searchReturnedEmpty}>
                    <div className={styles.searchEmptyContainer}>
                        <p className={styles.searchEmptyText}>Vi fant ingen spleiser som passer til søket ditt.</p>
                    </div>
                </VisibleIf>
                {numberOfProjects !== 0 ? (
                    <div className={styles.layoutContainer}>
                        <ProjectCardList
                            projectIds={projectIds}
                            projects={projects}
                            hideProjectImages={hideProjectImages}
                            actionInformation={actionInformation}
                        />
                    </div>
                ) : (
                    <div className={styles.extraSpace} />
                )}
            </div>
            {!hideSiteSearch && <SearchBanner theme="dark" />}
            <>
                <HowProjectWorks title="Slik virker Spleis" className={styles.howProjectWorks} />
            </>
        </div>
    );
};

export default ShowSelectedProjects;
